'use client'

import './app.scss'

import { Error } from '@marketplace-web/error-display/error-display-feature'

const title = 'Oops! Something went wrong.'
const body =
  "We apologize for the inconvenience, but it appears that we're experiencing some technical difficulties at the moment. Our team has already been alerted and is working to fix the issue. Thank you for your patience!"
const action = 'Reload'

type Props = {
  reset: () => void
}

const ErrorPage = ({ reset }: Props) => (
  <html lang="en">
    <body>
      <Error body={body} title={title} action={action} onActionClick={reset} />
    </body>
  </html>
)

export default ErrorPage
